import { render, staticRenderFns } from "./CommonReject.vue?vue&type=template&id=4daf02dd&scoped=true"
import script from "./CommonReject.vue?vue&type=script&lang=js"
export * from "./CommonReject.vue?vue&type=script&lang=js"
import style0 from "./CommonReject.vue?vue&type=style&index=0&id=4daf02dd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daf02dd",
  null
  
)

export default component.exports